export interface ValidationMixins {
  scrollToErrors(): void;
}

export const validationMixins: ValidationMixins = {
  scrollToErrors() {
    this.$nextTick(() => {
      scrollToFirstError.call(this);
    });
  },
};

function scrollToFirstError() {
  let offset = 0;

  // Top menu of the event website
  let offsetElement = document.querySelector<HTMLElement>('.nav');

  // Top menu of the organizer panel
  if (!offsetElement) {
    offsetElement = document.querySelector<HTMLElement>('.header');
  }

  if (offsetElement) offset = -(offsetElement.offsetHeight + 80);

  const firstError =
    Array.from(document.querySelectorAll('.js-validation-error')).find(elm => elm.textContent?.trim()) ||
    document.querySelector('.error');

  firstError && this.$scrollTo(firstError, { offset, force: true });
}
